import { SELECIONAR_ENDERECO_REMETENTE } from '../../actions/types'

const initialState = undefined

export default function reducerEnderecoRemetente (state = null, action = initialState) {
  switch (action.type) {
    case SELECIONAR_ENDERECO_REMETENTE: {
      return action.payload;
    }

    default: {
      return state
    }
  }
}
